import "./App.css";
import Home from "./components/Home";

function App() {
  return (
    <div className="App   font-mono">
      <Home />
    </div>
  );
}

export default App;
